import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

/** Serves the subscription PlanList and Addon catalog from src/assets/data/*.json instead of
 *  bundled TS constants, so editing plan/addon pricing, packages or Stripe keys only requires
 *  redeploying those JSON files, not a full ng build. load() is run to completion by an
 *  APP_INITIALIZER before the app bootstraps, so every consumer can keep reading `list`/`addons`
 *  synchronously exactly like the old `PlanList` import. */
@Injectable({
    providedIn: 'root'
})
export class PlanDataService {
    private planList: any[] = [];
    private addonList: any[] = [];

    constructor(private http: HttpClient) { }

    load(): Observable<[any[], any[]]> {
        return forkJoin([
            this.http.get<any[]>('assets/data/plan-list.json').pipe(catchError(() => of([]))),
            this.http.get<any[]>('assets/data/addon-list.json').pipe(catchError(() => of([]))),
        ]).pipe(
            tap(([plans, addons]) => {
                this.planList = Array.isArray(plans) ? plans : [];
                this.addonList = Array.isArray(addons) ? addons : [];
            })
        );
    }

    get list(): any[] {
        return this.planList;
    }

    get addons(): any[] {
        return this.addonList;
    }
}
